import BulletListInfo from "@/components/BulletListInfo";
import useProgramRedesignTraffic from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";
import { defaultItems } from "./constants";

const BulletListInfoSidebar = () => {
  const { sideRailBulletList } = useProgramRedesignTraffic();
  const isLightTheme = sideRailBulletList?.theme === "light";
  const title = sideRailBulletList?.title;
  const monarchItems = sideRailBulletList?.items;
  const detailItems =
    monarchItems !== undefined && monarchItems?.length > 0
      ? monarchItems
      : defaultItems;

  return (
    <div
      className={`p-3 rounded-xl ${isLightTheme ? "bg-white" : "bg-[#00262B]"}`}
    >
      <BulletListInfo
        title={title || "Invest in your carrer"}
        details={detailItems}
        titleFontClass={`!text-2xl ${isLightTheme && "!text-primary"}`}
        descriptionFontClass={`!text-sm ${isLightTheme && "text-primary"}`}
        containerClass="!gap-4"
        iconColor={isLightTheme ? "#00262B" : "white"}
      />
    </div>
  );
};
export default BulletListInfoSidebar;
